//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import React from 'react';

import { IUiaModalClosedResponse } from '@legacy-components/common/universal-image-actions/models/events';
import { UniversalImageActionsViewName } from '@models/UniversalImageActionsView';
import { addUiaCloseListener } from '@react-bridge/wrappers/legacy-events';
import { getUniversalImageActionsService } from '@react-bridge/wrappers/ng-service-provider';
import { IUiaLaunchOptions } from '@react-bridge/wrappers/ng-service-provider-types';
import Cuid from '@models/Cuid';

type UiaOnUpdateItem = (response: IUiaModalClosedResponse) => void;

export const openUia = (
  launchOptions: IUiaLaunchOptions,
  view: UniversalImageActionsViewName,
  onUpdateItem?: UiaOnUpdateItem,
  event?: React.MouseEvent,
) => {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const UniversalImageActionsService = getUniversalImageActionsService();

  UniversalImageActionsService.launch(view, launchOptions);
  if (onUpdateItem) {
    const unsubscribeFromUiaEvent = addUiaCloseListener(
      (response: IUiaModalClosedResponse) => {
        onUpdateItem(response);
        unsubscribeFromUiaEvent();
      },
    );
  }
};

/**
 * A shorthand method to open UIA to the product tagging workflow for a given cuid. Storing
 * here as a shortcut so that we can reuse it across scheduling features in the product CTAs.
 */
export const openUiaToProductize = (
  cuid: Cuid,
  onUpdateItem?: UiaOnUpdateItem,
) => {
  const { itemId, itemType } = Cuid.parse(cuid);
  openUia({ itemId, itemType }, 'Productize', onUpdateItem);
};
